/* GN 30-09 (v4) — snelle "+" op productkaarten via het EIGEN winkelwagenformulier van het thema
   + "Uitverkocht" op de foto bij uitverkochte producten.

   Waarom: de +-knop voegde toe via een los verzoek (/cart/add.js) en liet de drawer daarna door
   het thema openen. Het thema wist dan niet dat de winkelwagen veranderd was en toonde (na een
   paar producten) een oude versie. Eerdere pogingen om de drawer achteraf te verversen bleven
   racen met het thema.

   Nu: bij een klik op + maken we (onzichtbaar) precies het snelle-koop-formulier dat het thema
   zelf op productkaarten gebruikt (form.f8pr.form-card, action /cart/add) en versturen dat.
   Het thema (ajaxCart) handelt het af zoals op de productpagina: toevoegen, drawer vullen en
   openen. Er is dus nog maar één partij die de drawer beheert.

   Vangnet: pakt het thema het formulier niet op (bijv. thema-script nog niet geladen), dan voegen
   we zelf toe via /cart/add.js, halen de drawer vers op (sectie "side-cart") en openen hem.

   Raakt NIET: de productpagina-knoppen (hoofdknop, sticky balk, "vaak samen gekocht"),
   gn-site.js en gn-cro.js. Alleen de + op productkaarten en het uitverkocht-label. */
(function () {
  'use strict';
  if (window.__gnQuickAdd4) return;
  window.__gnQuickAdd4 = true;

  var DEBUG = function () { try { if (window.GN_DEBUG) console.log.apply(console, ['[gn-qa]'].concat([].slice.call(arguments))); } catch (e) {} };
  var ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ------------------------------------------------------------------
     1. "Uitverkocht" i.p.v. + op de foto
     ------------------------------------------------------------------ */
  function injectStyle() {
    if (document.getElementById('gn-qa4-style')) return;
    var st = document.createElement('style');
    st.id = 'gn-qa4-style';
    st.textContent =
      '#root .l4cl li figure .gn-soldout{position:absolute;right:12px;bottom:12px;z-index:60;display:inline-flex;align-items:center;' +
      'height:28px;padding:0 11px;border-radius:999px;background:rgba(255,255,255,.9);color:#1d1d1f;font-size:10.5px;line-height:1;' +
      'font-weight:700;letter-spacing:.08em;text-transform:uppercase;white-space:nowrap;pointer-events:none;' +
      'box-shadow:0 1px 2px rgba(0,0,0,.06),0 4px 14px rgba(0,0,0,.08),inset 0 0 0 .5px rgba(0,0,0,.08);' +
      '-webkit-backdrop-filter:saturate(180%) blur(12px);backdrop-filter:saturate(180%) blur(12px)}' +
      '@media (max-width:760px){#root .l4cl li figure .gn-soldout{right:8px;bottom:8px;height:24px;padding:0 9px;font-size:9.5px}}' +
      '#root .l4cl > li.unavailable > figure .gn-qa{display:none!important}' +
      'form.gn-qa-form{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;' +
      'border:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important}';
    (document.head || document.documentElement).appendChild(st);
  }

  function markSoldOut() {
    var items = document.querySelectorAll('.l4cl:not(.list) > li.unavailable');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.closest && li.closest('#cart')) continue;
      var fig = null;
      for (var c = 0; c < li.children.length; c++) if (li.children[c].tagName === 'FIGURE') { fig = li.children[c]; break; }
      if (!fig || fig.querySelector('.gn-soldout')) continue;
      var qa = fig.querySelector('.gn-qa');
      if (qa) qa.parentNode.removeChild(qa);
      var s = document.createElement('span');
      s.className = 'gn-soldout';
      s.textContent = 'Uitverkocht';
      fig.appendChild(s);
    }
  }

  /* ------------------------------------------------------------------
     2. Snel toevoegen via het thema-formulier
     ------------------------------------------------------------------ */
  function setState(b, st) {
    b.classList.remove('is-loading', 'is-added');
    if (st === 'loading') { b.classList.add('is-loading'); }
    else if (st === 'added') {
      b.classList.add('is-added'); b.innerHTML = CHECK;
      setTimeout(function () { b.classList.remove('is-added'); b.innerHTML = ICON; }, 2200);
    } else { b.innerHTML = ICON; }
  }

  function waitForTheme(ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function check() {
        if (window.ajaxCart && typeof window.ajaxCart.init === 'function') return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(check, 100);
      })();
    });
  }

  // Na verzenden: heeft het thema het formulier afgehandeld (preventDefault)?
  // Window-bubbel is de allerlaatste plek waar het event langskomt → hier kunnen we het veilig controleren.
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('gn-qa-form')) return;
    if (e.defaultPrevented) { f.__gnHandled = true; }
    else { e.preventDefault(); f.__gnFallback = true; }   // thema pakte het niet op → geen paginawissel, zelf toevoegen
  }, false);
  window.addEventListener('click', function (e) {
    var f = e.target && e.target.form;
    if (f && f.classList && f.classList.contains('gn-qa-form') && e.defaultPrevented) f.__gnHandledByClick = true;
  }, false);

  function viaTheme(li, variantId) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = (window.routes && window.routes.cart_add_url) || '/cart/add';
    form.setAttribute('accept-charset', 'UTF-8');
    form.setAttribute('enctype', 'multipart/form-data');
    form.setAttribute('novalidate', 'novalidate');
    form.setAttribute('aria-hidden', 'true');
    form.id = 'gn-qa-form-' + variantId + '-' + Date.now();
    form.className = 'f8pr form-card gn-qa-form';
    form.innerHTML =
      '<input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">' +
      '<fieldset><input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1">' +
      '<p class="submit"><button type="submit" class="overlay-buy_button" tabindex="-1">In winkelwagen</button></p></fieldset>';
    li.appendChild(form);
    try { window.ajaxCart.init(); } catch (e) { DEBUG('ajaxCart.init fout', e); }
    var btn = form.querySelector('button');
    btn.click();
    var ok = !!(form.__gnHandled || form.__gnHandledByClick) && !form.__gnFallback;
    DEBUG('thema-formulier verstuurd, afgehandeld door thema:', ok);
    setTimeout(function () { if (form.parentNode) form.parentNode.removeChild(form); }, 20000);
    return ok;
  }

  /* ---- vangnet: zelf toevoegen + drawer vers ophalen ---- */
  function drawerLink() {
    return document.querySelector('.shopify-section-header a[data-panel="cart"], header a[data-panel="cart"], #header a[href$="/cart"], header a[href$="/cart"]');
  }
  function money(cents) {
    try { if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, window.general && general.currency); } catch (e) {}
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  var gen = 0;
  function refreshDrawer() {
    var my = ++gen, stamp = Date.now();
    return Promise.all([
      origFetch((location.pathname || '/') + '?sections=side-cart&_gn=' + stamp, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
      origFetch('/cart.js?_gn=' + stamp, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      if (my !== gen) return;                                   // nieuwere verversing onderweg
      var cart = res[1], html = res[0] && res[0]['side-cart'];
      if (cart) {
        var cs = document.querySelectorAll('[id^="cart-count"]'); for (var i = 0; i < cs.length; i++) cs[i].textContent = cart.item_count;
        var ts = document.querySelectorAll('#cart-total, #cart-total--m'); for (var j = 0; j < ts.length; j++) ts[j].textContent = money(cart.total_price);
      }
      var drawer = document.getElementById('cart');
      if (!drawer || !html || !drawer.children.length) return;  // nooit geladen → thema laadt hem vers bij openen
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('.shopify-section') || tmp;
      var wrap = drawer.querySelector('.shopify-section');
      if (wrap) { wrap.innerHTML = fresh.innerHTML; }
      else {
        var keep = [];
        for (var k = 0; k < drawer.children.length; k++) { var ch = drawer.children[k]; if (ch.tagName === 'BUTTON' || /(^|\s)(close|overlay-close)(\s|$)/.test(ch.className || '')) keep.push(ch); }
        drawer.innerHTML = fresh.innerHTML; for (var m = 0; m < keep.length; m++) drawer.appendChild(keep[m]);
      }
      try { window.dispatchEvent(new CustomEvent('listCart')); } catch (e) {}
      try { if (window.ajaxCart && typeof ajaxCart.init === 'function') ajaxCart.init(); } catch (e) {}
      try { if (window.GN && typeof GN.renderDelivery === 'function') GN.renderDelivery(); } catch (e) {}
      DEBUG('drawer vers gezet:', cart && cart.item_count);
    });
  }
  function viaFetch(variantId, hasTheme) {
    return origFetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      // Zonder thema-script kan de drawer niet open: dan netjes naar de winkelwagenpagina (product zit erin)
      if (!hasTheme) { location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      var link = drawerLink();
      var drawer = document.getElementById('cart');
      var open = drawer && drawer.getAttribute('aria-hidden') === 'false';
      if (!open) { if (link) link.click(); else { location.href = '/cart'; return; } }
      // verversen nu, en nog eens na de open-animatie (het thema kan een oude versie terugzetten)
      refreshDrawer();
      setTimeout(refreshDrawer, 700);
      setTimeout(refreshDrawer, 1800);
    });
  }

  var busyCards = typeof WeakSet === 'function' ? new WeakSet() : null;
  function quickAdd(b) {
    var url = (b.getAttribute('data-url') || '').split('?')[0];
    var li = b.closest('li') || b.parentNode;
    if (!url) return;
    if (busyCards && busyCards.has(b)) return;
    if (busyCards) busyCards.add(b);
    setState(b, 'loading');
    var done = function (state) { if (busyCards) busyCards.delete(b); setState(b, state); };

    origFetch(url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (!p.variants || p.variants.length !== 1 || avail.length !== 1) { location.href = url; throw 'nav'; }
        var id = avail[0].id;
        return waitForTheme(8000).then(function (hasTheme) {
          if (hasTheme && viaTheme(li, id)) { done('added'); return; }
          DEBUG('vangnet: zelf toevoegen (thema geladen: ' + hasTheme + ')');
          return viaFetch(id, hasTheme).then(function () { done('added'); });
        });
      })
      .catch(function (err) {
        done('idle');
        if (err !== 'nav') location.href = url;
      });
  }

  // Window-capture: vóór de oude handler in gn-site.js (die op document zit) → die komt niet meer aan de beurt.
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button.gn-qa');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    quickAdd(b);
  }, true);

  /* ------------------------------------------------------------------
     3. Start + later geladen kaarten (filters, "meer laden", sliders)
     ------------------------------------------------------------------ */
  function init() { injectStyle(); markSoldOut(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var t = null;
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { clearTimeout(t); t = setTimeout(markSoldOut, 200); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
